var render = function render(){var _vm=this,_c=_vm._self._c;return _c('intern-file-upload',{attrs:{"year-select":false,"one-file-at-time":false,"download-file-list":_vm.currentFileNameListGetter},on:{"upload":_vm.upload,"download":_vm.download,"deleteFile":_vm.deleteFile}})
}
var staticRenderFns = []

export { render, staticRenderFns }